import {
  clearLegacyStorage,
  createUserScopedStorage,
} from 'switch-fe-shared/utils/browser-storage';

const legacyKeys = [
  'dashboard-template',
  'dashboard/utility',
  'dashboard/zone',
  'dateRangeFilter',
  'search-bookmark-items',
  'search-recent-items',
  'selectedAppId',
  'selectedGroupId',
  'utilTabValue',
];

const browserLocalStorage =
  typeof localStorage === 'undefined' ? undefined : localStorage;
const browserSessionStorage =
  typeof sessionStorage === 'undefined' ? undefined : sessionStorage;

clearLegacyStorage(browserLocalStorage, legacyKeys, ['sensors/']);
clearLegacyStorage(browserSessionStorage, legacyKeys, ['sensors/']);

const userStorageScope = createUserScopedStorage(
  browserLocalStorage,
  'admin-console'
);

export const userStorage = userStorageScope.storage;
export const getUserStorageOwner = userStorageScope.getUserId;
export const setUserStorageOwner = userStorageScope.setUserId;
